import { PUBLIC_GOOGLE_TAG_MANAGER_ID } from '$env/static/public'
import { PUBLIC_GOOGLE_ADS_ID } from '$env/static/public'
import type { TierId } from '@bruce/api/common/tier'

export async function initGoogleTagManager() {
  if (window) {
    await import(
      /* @vite-ignore */
      `https://www.googletagmanager.com/gtag/js?id=${PUBLIC_GOOGLE_TAG_MANAGER_ID}`
    )

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    window.dataLayer = window.dataLayer || []

    window.gtag = function gtag() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      // eslint-disable-next-line prefer-rest-params
      dataLayer.push(arguments)
    }

    window.gtag('js', new Date())
    window.gtag('config', PUBLIC_GOOGLE_TAG_MANAGER_ID)
    window.gtag('config', PUBLIC_GOOGLE_ADS_ID)
  }
}

function googleTagManagerBaseTrack(
  eventName: string,
  data:
    | Record<string, string | number | boolean | null | undefined>
    | undefined,
) {
  if (window?.gtag) {
    window.gtag('event', eventName, data)
  }
}

export const googleTagManagerTrack = {
  purchase: (data: {
    value: number
    currency: string
    tierId?: TierId
    amount?: number
    campaignCode: string | null
    type: 'membership' | 'credits'
    giftCard?: boolean
    trial?: boolean
  }) => googleTagManagerBaseTrack('purchase', data),
}

export const googleAdsTrack = {
  conversion: (data: {
    value: number
    currency: string
    giftCard?: boolean
    trial?: boolean
  }) =>
    googleTagManagerBaseTrack('conversion', {
      ...data,
      send_to: `${PUBLIC_GOOGLE_ADS_ID}/sEjeCPDB4coZEL3fjY4D`,
      transaction_id: '',
    }),
}
